import React, { useState } from "react";
import classnames from "classnames";

import styles from "./PriceRange.module.css";

interface Props {
  end: string;
  start: string;
  updateEnd: (end: string) => void;
  updateStart: (start: string) => void;
}

function PriceRange(props: Props) {
  const { end, start, updateEnd, updateStart } = props;
  const [valueEnd, setValueEnd] = useState("");
  const [valueStart, setValueStart] = useState("");
  const [errTip, setErrTip] = useState(false);
  return (
    <div className={styles.container}>
      <div className={styles.label}>价格区间</div>
      <div className={styles.value}>
        <button
          className={classnames(styles.default, {
            [styles.active]: end === "" && start === ""
          })}
          onClick={() => {
            setValueEnd("");
            setValueStart("");
            updateEnd("");
            updateStart("");
          }}
        >
          不限
        </button>
        <div className={styles.wrapper}>
          <span className={styles.symbol}>&#65509;</span>
          <input
            className={styles.input}
            onChange={event => {
              const { target } = event;
              const { value } = target;
              setValueStart(value.replace(/[^0-9]/g, ""));
            }}
            placeholder="最低价"
            type="text"
            value={valueStart}
          />
        </div>
        <div className={styles.spacer}></div>
        <div className={styles.wrapper}>
          <span className={styles.symbol}>&#65509;</span>
          <input
            className={styles.input}
            onChange={event => {
              const { target } = event;
              const { value } = target;
              setValueEnd(value.replace(/[^0-9]/g, ""));
            }}
            placeholder="最高价"
            type="text"
            value={valueEnd}
          />
        </div>
        {(valueEnd !== "" || valueStart !== "") && (
          <button
            className={styles.submit}
            onClick={() => {
              if(valueStart){
                if(valueEnd){
                  if(valueStart <= valueEnd){
                    updateEnd(valueEnd);
                    updateStart(valueStart);
                    setErrTip(false)
                  }else{
                    setErrTip(true)
                  }
                }else{
                  updateEnd(valueEnd);
                  updateStart(valueStart);
                  setErrTip(false)
                }
              }else{
                updateEnd(valueEnd);
                updateStart(valueStart);
                setErrTip(false)
              }
            }}
          >
            确定
          </button>
        )}
        {errTip && <div className={styles.errTip}>最低价应小于等于最高价，请重新填写</div>}
      </div>
    </div>
  );
}

export default PriceRange;
